import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const LOGO_URL = "/logo-header.png?v=blue3";

export default function Navbar({ variant = "hero" }) {
  const [open, setOpen] = useState(false);
  const onHero = variant === "hero";

  return (
    <nav
      className={`${
        onHero
          ? "sticky bg-white/95 backdrop-blur text-[var(--vp-primary)] border-b border-[var(--vp-border)]"
          : "sticky bg-white/95 backdrop-blur text-[var(--vp-primary)] border-b border-[var(--vp-border)]"
      } top-0 left-0 right-0 z-40 px-6 md:px-10 py-4 md:py-5 flex items-center justify-between gap-8 shadow-[0_2px_12px_rgba(0,0,0,0.04)]`}
      data-testid="main-navbar"
    >
      {/* LEFT-aligned logo on transparent background (black bg stripped via PIL). */}
      <Link to="/" className="flex-shrink-0" data-testid="nav-logo">
        <img
          src={LOGO_URL}
          alt="Vacations Pro"
          className="h-16 md:h-20 lg:h-24 w-auto object-contain"
          style={{ filter: "drop-shadow(0 4px 14px rgba(26,115,232,0.18))" }}
        />
      </Link>

      {/* Right nav — lean set: Packages, Honeymoon (VIP), Reviews, Journal, About, Seller */}
      <div className="hidden md:flex items-center justify-end gap-8 lg:gap-11">
        <Link to="/packages" className="text-[14px] tracking-[0.26em] uppercase font-black text-[var(--vp-primary)] hover:text-[var(--vp-secondary)] transition-colors" data-testid="nav-packages">Packages</Link>
        <Link to="/honeymoon-experiences" className="text-[14px] tracking-[0.26em] uppercase font-black text-[#a8874b] hover:text-[#8a6a2f] transition-colors relative" data-testid="nav-honeymoon">
          Honeymoon
          <span className="absolute -top-2 -right-6 text-[8px] tracking-[0.18em] font-bold bg-[#a8874b] text-white rounded-full px-1.5 py-0.5 leading-none">VIP</span>
        </Link>
        <a href="/#testimonials" className="text-[14px] tracking-[0.26em] uppercase font-black text-[var(--vp-primary)] hover:text-[var(--vp-secondary)] transition-colors" data-testid="nav-testimonials">Reviews</a>
        <a href="/#journal" className="text-[14px] tracking-[0.26em] uppercase font-black text-[var(--vp-primary)] hover:text-[var(--vp-secondary)] transition-colors" data-testid="nav-journal">Journal</a>
        <Link to="/about" className="text-[14px] tracking-[0.26em] uppercase font-black text-[var(--vp-primary)] hover:text-[var(--vp-secondary)] transition-colors" data-testid="nav-about">About</Link>
        <Link to="/admin" className="text-[14px] tracking-[0.26em] uppercase font-black text-[var(--vp-primary)] hover:text-[var(--vp-secondary)] transition-colors" data-testid="nav-admin">Seller</Link>
      </div>

      <button className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-[var(--vp-border)] p-6 flex flex-col gap-4 md:hidden text-[var(--vp-primary)]">
          <Link to="/packages" className="vp-label" onClick={() => setOpen(false)}>Packages</Link>
          <Link to="/honeymoon-experiences" className="vp-label text-[#a8874b] inline-flex items-center gap-2" onClick={() => setOpen(false)} data-testid="nav-honeymoon-mobile">
            Honeymoon <span className="text-[9px] tracking-[0.18em] font-bold bg-[#a8874b] text-white rounded-full px-1.5 py-0.5">VIP</span>
          </Link>
          <a href="/#testimonials" className="vp-label" onClick={() => setOpen(false)}>Reviews</a>
          <a href="/#journal" className="vp-label" onClick={() => setOpen(false)}>Journal</a>
          <Link to="/about" className="vp-label" onClick={() => setOpen(false)}>About</Link>
          <Link to="/admin" className="vp-label" onClick={() => setOpen(false)}>Seller</Link>
        </div>
      )}
    </nav>
  );
}
